"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spinner = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const spinner = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'spinner-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', 
            // eslint-disable-next-line max-len
            d: 'M10.7501 17C10.7501 17.4142 10.4143 17.75 10.0001 17.75C5.71987 17.75 2.25008 14.2802 2.25008 10C2.25008 5.71979 5.71987 2.25 10.0001 2.25C14.2803 2.25 17.7501 5.71979 17.7501 10C17.7501 10.4142 17.4143 10.75 17.0001 10.75C16.5859 10.75 16.2501 10.4142 16.2501 10C16.2501 6.54822 13.4519 3.75 10.0001 3.75C6.5483 3.75 3.75008 6.54822 3.75008 10C3.75008 13.4518 6.5483 16.25 10.0001 16.25C10.4143 16.25 10.7501 16.5858 10.7501 17Z', fill: '#4B5563' })));
};
exports.spinner = spinner;
